// @flow

import * as React from 'react';
import Button from '@ta/styleguide.button';
import { localize } from '@ta/common.i18n';

import styles from './LoadingErrorMessage.less';

/**
 * Full design implementation in TRVX-5063
 */

type Props = {
  refetch: () => mixed,
};

const LoadingErrorMessage = (props: Props) => (
  <div className={styles.error_block}>
    <p className={styles.error_heading}>
      {localize('social_loading_error_1')} {/* Whoops, something went wrong. */}
    </p>
    <p className={styles.error_body}>
      {localize('soical_loading_error_2')} {/* Give it another try please */}
    </p>
    <Button
      onClick={
        // Need to define a wrapper call, otherwise onClick will pass its own args!
        () => props.refetch()
      }
      type="primary"
      size="large"
    >
      <span>
        {localize('mobile_try_again')} {/* Try again */}
      </span>
    </Button>
  </div>
);

export default LoadingErrorMessage;
